import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, isDevMode } from '@angular/core';
import { PreloadAllModules, provideRouter, Router, withPreloading } from '@angular/router';
import { appRoutes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { httpInterceptorProviders } from '@client-monorepo/common/network';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HammerModule } from '@angular/platform-browser';
import 'hammerjs';
import { provideServiceWorker } from '@angular/service-worker';
import { JalaliDatePipe } from '@digipay/ng-lib-pipes';
import { MatDialogModule } from '@angular/material/dialog';
import { EnvironmentConfig, NgxApiConfigModule } from '@digipay/ngx-api-config';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { httpWealthInterceptorProviders } from '@client-monorepo/applets/wealth';
import { TraceService } from '@sentry/angular-ivy';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { CREDIT_ENVIRONMENT, getCreditEnvironment } from '@client-monorepo/applets/credit';
import { NgxEventTrackerModule } from '@digipay/ngx-event-tracker';
import { CustomErrorHandlerService } from './data-access/services/custom-error-handler.service';
import { CustomPreloadingStrategy } from './data-access/services/custom-preloading-strategy.service';
import { appInitializerFactory } from './utils/initializer';
import { UpdateInitializerService } from './data-access/services/update_initializer.service';

const environmentConfig: EnvironmentConfig = {
  agents: {
    web_agent: environment.agents.web_agent,
    android_agent: environment.agents.android_agent,
    ios_agent: environment.agents.ios_agent,
  },
  client_id: {
    web_clientId: environment.client_ids.web_username,
    android_clientId: environment.client_ids.android_hybrid_username,
    ios_clientId: environment.client_ids.ios_hybrid_username,
  },
  client_secret: {
    web_client_secret: environment.client_secrets.web_password,
    android_client_secret: environment.client_secrets.android_hybrid_password,
    ios_client_secret: environment.client_secrets.ios_hybrid_password,
  },
  digipayVersion: environment.digipay_version,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    { provide: ErrorHandler, useClass: CustomErrorHandlerService },
    provideHttpClient(withInterceptorsFromDi()),
    httpInterceptorProviders,
    httpWealthInterceptorProviders,
    { provide: 'APP_ENV', useValue: environment },
    importProvidersFrom(HammerModule),
    importProvidersFrom(MatDialogModule),
    importProvidersFrom(NgxApiConfigModule.environmentConfig(environmentConfig)),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializerFactory,
    //   multi: true,
    //   deps: [UpdateInitializerService],
    // },
    importProvidersFrom(
      NgxEventTrackerModule.forRoot({
        platforms: {
          gtm: {
            enabled: true,
          },
          intrack: {
            enabled: false,
          },
        },
        environment: {
          gtm_id: environment.google_tag_manager_id,
          intrack_config: environment.intrack_config,
          env: environment.env, // 'production', 'staging', etc.
        },
      }),
    ),
    JalaliDatePipe,
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    importProvidersFrom(WealthNavigationService),
    {
      provide: TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true,
    },
    {
      provide: 'STATE_BOTTOM_SHEET',
      useClass: NgxBottomSheetService,
    },
    {
      provide: CREDIT_ENVIRONMENT,
      useFactory: getCreditEnvironment,
    },
  ],
};

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'wealth-assets/i18n/', '.json');
}
